import { render, staticRenderFns } from "./FormBmf.vue?vue&type=template&id=30f2a6a8&scoped=true&"
import script from "./FormBmf.vue?vue&type=script&lang=js&"
export * from "./FormBmf.vue?vue&type=script&lang=js&"
import style0 from "./FormBmf.vue?vue&type=style&index=0&id=30f2a6a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f2a6a8",
  null
  
)

export default component.exports